<template>
  <div>
    {{ rule.config.ma_days }} moving average days, {{ rule.config.stddev }} standard deviations,
    Current Price {{ rule.config.above_below }} {{ rule.config.upper_lower }} band.
    <span v-if="rule.config.percent"
      >Closing Price {{ rule.config.percent }} % {{ rule.config.above_below }} BBand</span
    >
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {}
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
